import {CheckmarkCircleRegular, ErrorCircleRegular, InfoRegular, WarningRegular} from '@fluentui/react-icons';
import {makeStyles, Text, tokens} from '@fluentui/react-components';
import React from 'react';

type BannerVariant = 'info' | 'warning' | 'error' | 'success';

interface BannerProps {
    message: string;
    variant?: BannerVariant;
}

const VARIANT_STYLES: Record<BannerVariant, { bg: string; color: string; icon: React.ReactElement }> = {
    info: {
        bg: tokens.colorPaletteBlueForeground2,
        color: tokens.colorPaletteBlueForeground2,
        icon: <InfoRegular/>,
    },
    warning: {
        bg: tokens.colorPaletteYellowBackground2,
        color: tokens.colorPaletteYellowForeground2,
        icon: <WarningRegular/>,
    },
    error: {
        bg: tokens.colorPaletteRedBackground2,
        color: tokens.colorPaletteRedForeground2,
        icon: <ErrorCircleRegular/>,
    },
    success: {
        bg: tokens.colorPaletteGreenBackground2,
        color: tokens.colorPaletteGreenForeground2,
        icon: <CheckmarkCircleRegular/>,
    },
};

const useStyles = makeStyles({
    banner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: tokens.spacingHorizontalXS,
        padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalM}`,
        marginBottom: tokens.spacingVerticalS,
        textAlign: 'center',
    },
});

export default function Banner({message, variant = 'info'}: Readonly<BannerProps>) {
    const styles = useStyles();
    const {bg, color, icon} = VARIANT_STYLES[variant];

    return (
        <div className={styles.banner} style={{backgroundColor: bg, color}}>
            {icon}
            <Text size={200} style={{color}}>
                {message}
            </Text>
        </div>
    );
}